import moment from 'moment'

import TrainIcon from '@mui/icons-material/Train'
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation'

export default function ({ passType, subType, variables }) {
  try {
    if (passType === "transit" && subType === "RAIL") {

      let journey = variables.journey
      let legs = journey?.legs

      if (legs?.length) {
        return (
          <div>
            <table width="100%" cellPadding="3px" className="text mb-10">
              <tbody>
                {legs.map((leg, idx) => <FormatLeg key={idx} leg={leg} lastleg={idx === legs.length - 1}/>)}
              </tbody>
            </table>
          </div>
        )
      }
    }
  }
  catch (err) {
    console.error(err)
  }
}

const FormatLeg = ({ leg, lastleg }) => {
  return (
    <>
      <tr>
        <td valign="top" rowSpan={3} style={{ position: "relative" }}>
          <div style={{ backgroundColor: "#FFDDDD", borderRadius: 10, top: 2, bottom: 2, position: "absolute", left: 2, width: 14 }} />
          <TrainIcon style={{ position: "absolute", top: 0, left: 0, backgroundColor: "white", fontSize: 20, padding: 2, borderRadius: 10, outline: "1px solid #eee" }} />
          <div style={{ backgroundColor: "white", borderRadius: 10, position: "absolute", bottom: 4, left: 4, width: 10, height: 10 }}>&nbsp;</div>
        </td>
        <td><span className="label">{leg.origin.name}</span><br />{leg.toc}</td>
        <td valign="top">{moment(leg.depart,"YYYYMMDDHHmmss").format("HH:mm")}</td>
      </tr>
      <Seats reservation={leg.reservation} />
      <tr>
        <td><span className="label">{leg.destination.name}</span></td>
        <td>{moment(leg.arrive,"YYYYMMDDHHmmss").format("HH:mm")}</td>
      </tr>
      {!lastleg && formatTransfer()}
    </>
  )
}


const formatTransfer = () => (
  <>
    <tr><td colSpan={3}><hr style={{ margin: 0 }} /></td></tr>
    <tr>
      <td className="pb-3"><TransferWithinAStationIcon /></td>
      <td>Transfer</td>
    </tr>
    <tr><td colSpan={3}><hr style={{ margin: 0 }} /></td></tr>
  </>
)


const Seats = ({ reservation }) => {
    if (reservation) {
      return (
        <tr>
          <td align="left" className="pb-3">
            <div className="flex flex-col">Coach {reservation.coach}</div>
          </td>
          <td align="right" className="pb-3 text-nowrap">
          <div className="flex flex-col">Seat {reservation.seat}</div>
          </td>
        </tr>
      )
    } else {
      return (
        <tr>
          <td colSpan={2} align="right" className="pb-3">No Assigned Seat(s)</td>
        </tr>
      )
    }
}